/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Delete_ConfirmInputs */

const en_admin_permissions_delete_confirm = /** @type {(inputs: Admin_Permissions_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this permission? It will be removed from all roles.`)
};

const zh_admin_permissions_delete_confirm = /** @type {(inputs: Admin_Permissions_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确定要删除此权限吗？它将从所有角色中移除。`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this permission? It will be removed from all roles." |
*
* @param {Admin_Permissions_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_delete_confirm = /** @type {((inputs?: Admin_Permissions_Delete_ConfirmInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Delete_ConfirmInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_delete_confirm(inputs)
	return zh_admin_permissions_delete_confirm(inputs)
});
export { admin_permissions_delete_confirm as "admin.permissions.delete_confirm" }